(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8024],{

/***/ 55357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./src/constants/index.ts + 6 modules
var constants = __webpack_require__(22120);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/tradesy-vacation-mode/index.tsx









function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-08-05",
      tag: "Tradesy",
      title: "Take a selling break in peace with Tradesy Vacation Mode",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Like other working individuals, online sellers need a break from time to time. Personal time off is essential even if there's no boss to seek vacation leave approval from or a physical store window to shutter for the meantime."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "While some would be fine with working while on holiday, you might be one of those who like to completely unplug, whether by choice or not (if the connection is spotty where you are going) when vacationing."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "On Tradesy, sellers have the option to enjoy a hiatus while maintaining the visibility of their listings. By activating Vacation Mode, your items will still appear on search results. The only difference is that these items will be marked as unable to be purchased until your specified return date."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Potential buyers will then have the option to receive a notification once you've returned and the item is finally available for check out. This gives your listings a chance to still be viewed and earmarked for purchase when you come back."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Now, to avail of this Tradesy feature, you don't necessarily have to be away for a trip. You may activate Vacation Mode anytime you need a break \u2013 even a mental one. There are other instances when this feature may come in handy, such as:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You are sick or need to deal with an emergency."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You are overwhelmed with personal or business matters."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You want to slow down to focus on strategic planning for your shop."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You feel burned out."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This will allow you to take a breather without wiping your presence off on the platform."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "While there's no guarantee that potential buyers would opt-in on the \"Notify Me When Item is Available\" prompt, there's a good chance they would do so, especially if they truly like the items and the waiting time is not that long. Depending on the quality of your listings, as well as the duration of your hiatus, you should be able to find some messages and potential sales waiting upon your return."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The return date may be set anytime within three months only. If you intend to be gone for a longer time, consider taking a break from your break. You may want to return and be ready to process orders for items that generated interest while you're away or delegate the task to someone you trust to keep an active presence on Tradesy and go on Vacation Mode again."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Tradesy Vacation Mode can only be activated on a web browser and is not yet available on the app. You can log on to your account, hover to the top of the toolbar, and click on your profile picture or initials. You should find the feature under Closet Settings."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Another way to activate it is through the Start Selling button. If you're using a desktop browser, it's in the top right-hand corner. Don't forget to double-check the return date before hitting the Save button."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Note that the first day of your Vacation Mode is, by default, the day you turn on the feature. It cannot be scheduled for a later date. Remember to activate it on the correct date to avoid any confusion or miscommunication with your buyers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Take a break, and take it easy with a smart seller tool."
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As a seller, increasing your sales is the ultimate goal, and to do this, you have to make sure that your listings are visible to as many online shoppers as possible \u2013 even while you're on vacation. OneShop makes it possible as it can help you easily crosslist to other marketplaces by allowing you to import your existing listings and then cross-list them to other marketplaces with minimal effort."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "With its time-saving features such as Duplicating Listings, sellers can create a new draft listing from an existing one you've created on OneShop. No need to start from scratch every single time."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Another feature that would be especially helpful for sellers about to go on vacation mode is Scheduled Listing. If you have many items to list before your trip but don't want to post everything all at once, this feature fits the bill. It allows you to prepare listings with an option to be posted up to a week in advance."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Let OneShop help you automate tasks and cross-list across multiple platforms to grow your business. Start your", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: constants/* Marketing.TrialDuration */.F1.TrialDuration
        }), "-day free trial today with no risks involved and", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "",
          children: "get set up"
        }), " within three minutes. See how this automation service can improve your reselling operations."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/tradesy-vacation-mode.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Take a selling break in peace with Tradesy Vacation Mode"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Your listings and potential sales need not go on a break with you. Keep your items visible with this must-know Tradesy seller feature."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/tradesy-vacation-mode"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/tradesy-vacation-mode"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Take a selling break in peace with Tradesy Vacation Mode"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Your listings and potential sales need not go on a break with you. Keep your items visible with this must-know Tradesy seller feature."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-08-05T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-08-05T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Tradesy"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 9040:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/tradesy-vacation-mode",
      function () {
        return __webpack_require__(55357);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(9040); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);